
const initState = {
    booleanIPhoneAppModalIsOpen: false,
    booleanChromeBrowserModalIsOpen: false,
    booleanAndroidAppModalIsOpen: false,
    IPhoneEmailAddress: '',
    ChromeEmailAddress: '',
    booleanTriggersIPhoneEmailSignup: false,
    booleanTriggersChromeEmailSignup: false,

};

const triggerReducer = (state=initState, action) => {
    
    switch (action.type) {

        case 'TRIGGER_MODALS':
            return{
                ...state,
                booleanIPhoneAppModalIsOpen: action.booleanIPhoneAppModalIsOpen,
                booleanChromeBrowserModalIsOpen: action.booleanChromeBrowserModalIsOpen,
                booleanAndroidAppModalIsOpen: action.booleanAndroidAppModalIsOpen,

            }

        case 'ADDED_IPHONE_EMAIL':

            return {
                ...state,
                IPhoneEmailAddress: action.emailAddress,
                booleanTriggersIPhoneEmailSignup: true,
            }

        case 'ADDED_CHROME_EMAIL':

            return {
                ...state,
                ChromeEmailAddress: action.emailAddress,
                booleanTriggersChromeEmailSignup: true,
            }

        default:
            return state;
           
    }

}



export default triggerReducer

